// Theme Colors
// Initially this will be blank. Later on when app is initialized we will assign bootstrap colors to this from CSS variables.

// import psl from 'psl'

export const $themeColors = {}

const host = 'Office'
// // eslint-disable-next-line no-unused-vars
// if (`${process.env.VUE_APP_IS_TENANT}` === '0' || `${process.env.VUE_APP_IS_TENANT}` === '1') {
//   const url = window.location.host
//   if (url.indexOf('.curfox.com') !== -1) {
//     // eslint-disable-next-line prefer-destructuring
//     host = url.split('.')[0]
//   } else {
//     const parsed = psl.parse(url)
//     console.log(parsed)
//     // eslint-disable-next-line prefer-destructuring
//     const name = parsed.input
//     // eslint-disable-next-line
//     host = name.split(':')[1]
//   }
// } else {
//   host = 'curfox'
// }

// App Breakpoints
// Initially this will be blank. Later on when app is initialized we will assign bootstrap breakpoints to this object from CSS variables.
export const $themeBreakpoints = {}

// APP CONFIG
export const $themeConfig = {
  app: {
    appName: host, // Will update name in navigation menu (Branding)
    // eslint-disable-next-line global-require
    appLogoImage: require('@/assets/images/logo/logo.jpg'), // Will update logo in navigation menu (Branding)
  },
  layout: {
    isRTL: false,
    skin: 'light', // light, dark, bordered, semi-dark
    routerTransition: 'zoom-fade', // zoom-fade, slide-fade, fade-bottom, fade, zoom-out, none
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      hidden: false,
      isCollapsed: false,
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: '', // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static', // static, sticky, hidden
    },
    customizer: true,
    enableScrollToTop: true,
  },
}
